import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import http from './utils/http'
import api from './utils/api'

import VueSplide from '@splidejs/vue-splide'
const app = createApp(App);
app.use(store).use(router).use(VueSplide).mount('#app');